import { PropsWithChildren } from 'react';

const DEFAULT_PRECISION = 3;

type PercentageDisplayProps = {
  precision?: number
}

export function formatPercentage(number: any, precision?: number) {
  return formatNumber(Number(number), precision, 'percent').replace(' ', '');
}

export function formatNumber(number: any, precision?: number, style = 'decimal') {
  const formatter = new Intl.NumberFormat('es-CO', {
    maximumFractionDigits: precision === undefined ? DEFAULT_PRECISION : precision,
    minimumFractionDigits: 0,
    style
  });

  return formatter.format(number);
}

const PercentageDisplay = ({ precision, children } : PropsWithChildren<PercentageDisplayProps>) => {
  return <span>{formatPercentage(children, precision)}</span>
};

export default PercentageDisplay;